export default __webpack_public_path__ + "static/media/no-palm-oil-000000.12053962.png";